/**
 * Permission codes cho module Vận hành (P4 gộp kho vào banhang).
 *
 * Key = value = mã chức năng trên SSO (`WEB_KHO_*`), khớp menu
 * `auth-frontend/.../banhang/web/banHangWebMenu.ts`.
 *
 * ⚠️ ARTIFACT TYPE-SAFETY + DOCUMENTATION — KHÔNG phải enforcement.
 * Enforcement thực tế = 100% external SSO qua `CompositeAuthGuard` (pathKey).
 * Register vào `ALL_CHUCNANG_PERMISSION_CODES` (src/constants/permissionConstants.ts).
 */

/** Quyền web kho: `WEB_KHO_*`. Thông báo là `WEB_BH_THONG_BAO`. */
export const VAN_HANH_PERMISSION_CODES = {
  // Đơn hàng vận hành (màn Tất cả đơn hàng + Gán nhân viên)
  WEB_KHO_DON_TAT_CA: 'WEB_KHO_DON_TAT_CA',
  WEB_KHO_DON_XUAT: 'WEB_KHO_DON_XUAT',
  WEB_KHO_DON_RESET: 'WEB_KHO_DON_RESET',
  WEB_KHO_GAN_NHAT: 'WEB_KHO_GAN_NHAT',
  WEB_KHO_GAN_DONG: 'WEB_KHO_GAN_DONG',
  WEB_KHO_GAN_GIAO: 'WEB_KHO_GAN_GIAO',
  WEB_KHO_BAO_CAO: 'WEB_KHO_BAO_CAO',
  /** Màn `/admin/report/don-hang` — kế thừa từ `WEB_KHO_BAO_CAO` khi sync. */
  WEB_KHO_BAO_CAO_DON: 'WEB_KHO_BAO_CAO_DON',
  WEB_KHO_BAO_CAO_XUAT: 'WEB_KHO_BAO_CAO_XUAT',
  // Bước 1 — Xếp nhặt
  WEB_KHO_NHAT_XEM: 'WEB_KHO_NHAT_XEM',
  WEB_KHO_NHAT_SUA: 'WEB_KHO_NHAT_SUA',
  WEB_KHO_NHAT_XOA: 'WEB_KHO_NHAT_XOA',
  // Bước 2 — Kiểm tra
  WEB_KHO_KIEM_XEM: 'WEB_KHO_KIEM_XEM',
  WEB_KHO_KIEM_SUA: 'WEB_KHO_KIEM_SUA',
  WEB_KHO_KIEM_XOA: 'WEB_KHO_KIEM_XOA',
  // Bước 3 — Đóng gói
  WEB_KHO_DONG_XEM: 'WEB_KHO_DONG_XEM',
  WEB_KHO_DONG_SUA: 'WEB_KHO_DONG_SUA',
  WEB_KHO_DONG_XOA: 'WEB_KHO_DONG_XOA',
  // Bước 4 — Điều phối
  WEB_KHO_DIEU_PHOI_XEM: 'WEB_KHO_DIEU_PHOI_XEM',
  WEB_KHO_DIEU_PHOI_SUA: 'WEB_KHO_DIEU_PHOI_SUA',
  WEB_KHO_DIEU_PHOI_XOA: 'WEB_KHO_DIEU_PHOI_XOA',
  // Bước 5 — Giao hàng nội bộ
  WEB_KHO_GIAO_XEM: 'WEB_KHO_GIAO_XEM',
  WEB_KHO_GIAO_SUA: 'WEB_KHO_GIAO_SUA',
  WEB_KHO_GIAO_XOA: 'WEB_KHO_GIAO_XOA',
  // Quét mã QR bàn giao
  WEB_KHO_QUET_MA: 'WEB_KHO_QUET_MA',
  // In phiếu vận hành
  WEB_KHO_IN_PHIEU: 'WEB_KHO_IN_PHIEU',
  // Trung tâm thông báo
  WEB_BH_THONG_BAO: 'WEB_BH_THONG_BAO',
} as const
